import { motion } from "motion/react";
import { cn } from "@babackapp/customer-ui/lib/utils";
import { cva, VariantProps } from "class-variance-authority";

const widgetPageVariants = cva("flex flex-col gap-10 compact:gap-4 w-full flex-1 min-h-0 pt-20", {
  variants: {
    variant: {
      default: "",
      // Plain `justify-center` makes the overflow above the centered content
      // unreachable by scroll: on a short viewport (12" laptop, most phones)
      // the logo sits above the visible area with no way to scroll up to it.
      // `-safe` falls back to start-alignment once the content no longer fits,
      // which keeps everything scrollable into view instead.
      centered: "justify-center-safe flex h-full -pt-24",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export function WidgetPage({
  className,
  variant,
  ...props
}: React.ComponentProps<typeof motion.div> &
  VariantProps<typeof widgetPageVariants>) {
  return (
    <motion.div
      className={cn(widgetPageVariants({ variant, className }), className)}
      {...props}
    />
  );
}
